import styled from 'styled-components'

import { colors, spacing } from 'Global/theme'
import { family, weight } from 'Global/font'
import { BREAKPOINTS } from 'Global/constants'

export const Container = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;

  > :not(:first-child) {
    margin-top: ${spacing.two};
  }

  > :last-child {
    margin-top: ${spacing.three};
  }
`

export const GroupContainer = styled.div`
  width: 100%;
  min-width: ${({ device }) => device === BREAKPOINTS.MOBILE && '300px'};
  min-height: ${({ device }) => device === BREAKPOINTS.MOBILE && 'auto'};
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: ${({ device }) => device === BREAKPOINTS.MOBILE ? 'space-between' : 'flex-start'} ;
  align-items: flex-start;

  padding: ${spacing.half} ${spacing.two} ${spacing.two};

  border-radius: 8px;
  border-style: solid;
  border-color: ${colors.primary.regular};
  border-width: 2px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;

  > :first-child {
    margin-bottom: ${spacing.two};
  }
`

export const GroupLabel = styled.div`
  color: ${colors.primary.dark};
  font-size: 16pt;
  ${family.openSans};
  ${weight.semiBold};
`
